import React, { useState } from "react";
import { useParams } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Check, Mail } from "lucide-react";

export default function UnsubscribePage() {
  const { trackingId } = useParams();
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [email, setEmail] = useState("");

  const confirm = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/emails/unsubscribe/${trackingId}`);
      setEmail(r.data.email || "");
      setDone(true);
      toast.success("Baja confirmada");
    } catch (e) {
      toast.error(formatApiError(e) || "Enlace no válido");
    } finally {
      setBusy(false);
    }
  };

  return (
    <PublicLayout>
      <div className="max-w-lg mx-auto py-24 px-4 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center mb-6">
          {done ? <Check className="w-8 h-8 text-primary" /> : <Mail className="w-8 h-8 text-primary" />}
        </div>
        {!done ? (
          <>
            <h1 className="text-3xl font-bold text-foreground font-display">Darse de baja</h1>
            <p className="mt-3 text-sm text-muted-foreground">
              ¿Ya no quieres recibir emails de marketing de DCC? Confirma tu baja.
              Los emails transaccionales seguirán llegando (facturación, órdenes).
            </p>
            <button
              onClick={confirm}
              disabled={busy}
              data-testid="unsubscribe-confirm-btn"
              className="mt-6 px-6 py-3 rounded-md bg-primary hover:brightness-110 text-primary-foreground font-semibold text-sm disabled:opacity-60"
            >
              {busy ? "Procesando…" : "Confirmar baja"}
            </button>
          </>
        ) : (
          <>
            <h1 className="text-3xl font-bold text-foreground font-display">¡Baja confirmada!</h1>
            <p className="mt-3 text-sm text-muted-foreground">
              {email ? <>Registramos la baja de <strong>{email}</strong>.</> : "Tu email fue removido de nuestras listas de marketing."}
              <br />No recibirás más campañas promocionales.
            </p>
            <a
              href="/"
              className="mt-6 inline-block text-sm text-primary hover:underline"
            >
              Volver al inicio →
            </a>
          </>
        )}
      </div>
    </PublicLayout>
  );
}
